import { PropsWithChildren } from "react";

import { Input, InputProps } from "@mui/material";
import { useField } from "formik";

import { getError } from "../../../misc/formHelpers";
import { FormErrorMessage } from "../FormErrorMessage/FormErrorMessage";

export type FormInputProps = PropsWithChildren<
  Omit<InputProps, "onChange" | "onBlur" | "value">
>;

const FormInput = (props: FormInputProps) => {
  const fieldProps = useField(props.name || "");
  const field = fieldProps[0];
  const meta = fieldProps[1];

  return (
    <>
      <Input
        {...field}
        error={!!getError(meta)}
        onBlur={(e) => {
          field.onBlur(e);
        }}
        onChange={(e) => {
          field.onChange(e);
        }}
        {...props}
      />
      <FormErrorMessage name={field.name} />
    </>
  );
};

export { FormInput };
